import { Button, DropDownInput } from "@/components";
import { useState } from "react";
import { HiOutlineDownload, HiOutlineUpload } from "react-icons/hi";
import { SheetClose } from "@/components/ui/sheet";
import { UploadInput } from "@/components";
import { useAlert } from "@/";
const BulkOrder = ({ onSubmit }) => {
  const [fromData, setFormData] = useState({
    bulkBooking: null,
  });
  const { alert, AlertDialog } = useAlert();

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    if (!fromData.bulkBooking) {
      await alert("Please upload order sheet.");
      return;
    }
    onSubmit(fromData);
  };

  return (
    <div className="flex flex-col gap-10 pl-2">
      <div className="flex flex-col gap-6">
        {/* Step 1 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">1.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Download sample order sheet
            </p>
          </div>
          <div className="flex gap-2 justify-start items-center ml-6">
            <Button
              variant="default"
              size="sm"
              icon={HiOutlineDownload}
              onClick={() => {
                window.location.href =
                  "https://api.indiancouriercompany.com/samples/Bulk_Booking.csv";
              }}
            >
              Sample Sheet
            </Button>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">2.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Upload updated order sheet
            </p>
          </div>
          <div className="flex gap-2 justify-center items-center ml-6">
            <UploadInput
              label=""
              placeholder="Upload Order Sheet"
              note="Note: Only .csv file is allowed"
              accept=".csv"
              onChange={(file) => handleChange("bulkBooking", file)}
            />
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="flex gap-2 justify-end items-center mt-4">
        <SheetClose asChild>
          <Button variant="outline" size="sm">
            Cancel
          </Button>
        </SheetClose>
        <Button
          variant="default"
          size="sm"
          icon={HiOutlineUpload}
          onClick={handleSubmit}
        >
          Upload Bulk Order
        </Button>
      </div>
    </div>
  );
};

export default BulkOrder;
